import { datasource } from "./datasource";

export const jobDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("job", {
    model: {
      id: "id",
      fields: {
        id: {
          type: "string",
        },
        ball_id: {
          type: "string",
        },
        ball: {
          type: "raw",
        },
        location_id: {
          type: "string",
        },
        operator_id: {
          type: "string",
        },
        date_created: {
          type: "string",
        },
        date_due: {
          type: "string",
        },
        date_completed: {
          type: "string",
        },
        status: {
          type: "string",
        },
        note: {
          type: "string",
        },
        discount: {
          type: "number",
        },
        job_details: {
          type: "raw",
        },
        sales_person: {
          type: "string",
        },
        job_location: {
          type: "string",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
      },
    },
  });
